export const headerHeight = {
  mobile: '64px',
  tablet: '84px',
  desktop: '90px',
};
